module.exports = __webpack_public_path__ + "81af50e2802e02eb8f10cdde64c2a222.jpg";